import React, { useState, useCallback, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Emty from "../../components/Emty/Emty";
import UseProjectCommon from "../../hooks/UseProjectCommon";
import { formatDate } from "../../lib/lib";
import "./css/index.css";

type Props = {};

/** 인증서 관리 페이지 */
const Certification = (props: Props) => {
  const navigate = useNavigate();
  const [search, setsearch] = useState<string>("");
  const [data] = UseProjectCommon({
    type: "prjt",
    filter: "&prjt_sts_cd=prjt_sts_ing,prjt_sts_end",
    time: "",
  });
  // const __searchInit = useCallback(() => {
  //   if (search) {
  //     const clone = box.slice();
  //     setData(clone.filter(({ name }) => name.includes(search)));
  //   } else {
  //     setData(box);
  //   }
  // }, [search]);
  const NavDetail = useCallback(
    (id: string) => {
      navigate("/etc/certification/detail", { state: id });
    },
    [navigate]
  );
  useLayoutEffect(() => {
    // officeApi()
    return () => {};
  }, []);
  return (
    <main className="certification-page">
      <div className="wrapper">
        <div className="cert-title-wrapper">
          <div className="left">
            <p>인증서 관리</p>
          </div>
          <div className="right">
            <form
              className="cert-search-box"
              onSubmit={(e) => {
                // __searchInit();
                e.preventDefault();
              }}
            >
              <input
                type="text"
                className="search-input"
                placeholder="검색"
                onChange={(e) => {
                  setsearch(e.target.value);
                }}
              ></input>
              <img
                className="search"
                src="/assets/common/search.svg"
                alt="검색"
              />
            </form>
            <button className="search-btn" onClick={() => {}}>
              검색
            </button>
          </div>
        </div>
        {data.length > 0 ? (
          <React.Fragment>
            <div className="sub">
              <div className="tag-wrapper">
                <div className="name">프로젝트명</div>
                <div className="timestamp">모집마감일</div>
                <div className="leader">팀리더</div>
              </div>
            </div>
            <div className="list">
              {data.map(
                (
                  { prjt_nm, rcrt_apply_en_at, leadr_usr_nm, prjt_id },
                  index
                ) => {
                  return (
                    <div key={index} className={`cert-card`}>
                      <div className="info-wrapper">
                        <div className="name">{prjt_nm}</div>
                        <div className="timestamp">
                          {formatDate(rcrt_apply_en_at, "-")}
                        </div>
                        <div className="leader">{leadr_usr_nm}</div>
                      </div>
                      <div className="btn-wrapper">
                        <button
                          className="detail-btn"
                          onClick={() => {
                            NavDetail(prjt_id);
                          }}
                        >
                          상세보기
                        </button>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </React.Fragment>
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
};

export default Certification;

const box = [
  {
    name: "삼성 프로젝트 매니저와 함께하는 기업 프로젝트",
    id: "dsfvsdv",
    timestamp: Date.now(),
    leader: "츠비비",
  },
];
